import { ClientAnalytics } from './clientAnalytics'
import type { VoiceTopic } from '@/store/voiceAtoms'

/** Where the feedback dialog was opened from — used for open-event attribution. */
export type VoiceOpenSource = 'sidebar' | 'footer' | 'release_notes' | 'workspace_settings'

/** How an image entered the form. */
export type VoiceImageMethod = 'picker' | 'paste' | 'drop'

// ── Dialog lifecycle ──
type LifecycleEvent =
  | 'user_voice:open'
  | 'user_voice:dismiss'

// ── Form interaction ──
type FormEvent =
  | 'user_voice:topic_change'
  | 'user_voice:image_attach'
  | 'user_voice:image_remove'
  | 'user_voice:image_rejected'

// ── Submission ──
type SubmitEvent =
  | 'user_voice:submit'
  | 'user_voice:submit:success'
  | 'user_voice:submit:failed'

export type UserVoiceAnalyticsEvent =
  | LifecycleEvent
  | FormEvent
  | SubmitEvent

interface VoiceOpenProperties {
  source: VoiceOpenSource
  presetTopic?: VoiceTopic
}

export function trackUserVoice(event: 'user_voice:open', properties: VoiceOpenProperties): void
export function trackUserVoice(event: Exclude<UserVoiceAnalyticsEvent, 'user_voice:open'>, properties?: Record<string, unknown>): void
export function trackUserVoice(
  event: UserVoiceAnalyticsEvent,
  properties?: VoiceOpenProperties | Record<string, unknown>
) {
  ClientAnalytics.track(event, properties as Record<string, unknown> | undefined)
}
